module.exports = __webpack_public_path__ + "img/signup.6ef74975.png";